<dashboardnav>

  <cradua-measuring-factor
  [measures]="measures$ | async"
  [measuringfactors]="measuringfactors$ | async"

  (changeEmit)="onSubmitMeasuringFactor($event)"
  (deleteEvent)="onDeleteMeasuringFactor($event)"
  *ngIf="
  !(isLoadingMeasure$ | async ) &&
  !(isLoadingMeasuringFactor$ | async )
  "
  >
</cradua-measuring-factor>

  <mrsoftapps-epims-reference-spinner
  *ngIf="
  (isLoadingMeasure$ | async ) ||
  (isLoadingMeasuringFactor$ | async )
  "
>
  </mrsoftapps-epims-reference-spinner>
</dashboardnav>
